import * as App from './';
import { ZZFXLib } from '../lib/classes';
import { isTouchDevice } from '../lib/utils/isTouchDevice';
import { random } from '../lib/utils/match/random';
var IS_TOUCH_DEVICE = isTouchDevice();
var initSoundEventName = IS_TOUCH_DEVICE ? 'touchstart' : 'click';
var initSoundListenerAttached = false;
var resumeOnClick = function () {
    ZZFXLib.resume().then(function () { return console.log('ZZFXLib resume done'); });
    window.removeEventListener(initSoundEventName, resumeOnClick);
    initSoundListenerAttached = false;
};
export var playSound = function (seed, volume) {
    if (volume === void 0) { volume = 0.15; }
    if (!App.storage.get().mute) {
        if (ZZFXLib.state() === 'running') {
            new ZZFXLib().z(seed, { volume: volume });
        }
        else if (!initSoundListenerAttached) {
            window.addEventListener(initSoundEventName, resumeOnClick);
        }
    }
};
export var click = function () { return playSound(40846); };
export var clickButton = function () { return playSound(45113); };
export var match = function () { return playSound(52074); };
export var rotate = function () { return playSound(12344); };
export var disabled = function () { return playSound(19962); };
if (DEVELOPMENT) {
    // @ts-ignore
    window.randomSound = function (r) {
        r = r || random(1, 100000);
        console.log('randomSound', r);
        playSound(r);
    };
}
